<template>
    <div class="col-12 text-center">
        <h1 class="h4">{{ title }}</h1>
        <p v-if="description.length > 0" class="mt-3">
            {{ description | truncate(150, '...', this.expanded) }}
            <span class="read_more" v-if="!expanded" @click="toggleReadMore">read more</span></p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            expanded: false
        };
    },
    props: {
        title: {
            type: String
        },
        description: {
            type: String
        }
    },
    mounted() {
        document.addEventListener('read-less-clicked', this.toggleReadMore);
    },
    beforeUnmount() {
        document.removeEventListener('read-less-clicked');
    },
    methods: {
        toggleReadMore() {
            this.expanded = !this.expanded;
            var content = document.querySelector('#seo_text');

            if(content) {
                if (content.classList.contains('d-block')) {
                    content.classList.remove('d-block');
                    content.classList.add('d-none');
                } else {
                    content.classList.add('d-block');
                    content.classList.remove('d-none');
                }
            }

        }
    },
    filters: {
        truncate: function (text, length, suffix, display) {
            if(display) {
                return text;
            }

            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
        },
    }
};
</script>

<style scoped>
    .read_more {
        color: #1D4C9A;
    }

    .read_more:hover {
        cursor: pointer;
    }
</style>
